import { useEffect } from "react"

import useLoginStatusQuery from "../../../api/login/useLoginStatusQuery"
import { redirectToLogin } from "../../../logic/auth/returnUrl"

const scrollToHashWithoutSmooth = () => {
  const target = document.getElementById(window.location.hash.slice(1))
  if (target === null) return

  const htmlElement = document.documentElement
  const existing = htmlElement.style.scrollBehavior
  htmlElement.style.scrollBehavior = "auto"
  target.scrollIntoView()
  htmlElement.style.scrollBehavior = existing
}

type RequiredAuthProps = {
  children: React.ReactNode
  enabled: boolean
  fallback?: React.ReactElement
}

export const RequiredAuth = ({ children, enabled, fallback }: RequiredAuthProps) => {
  const { isLoggedIn } = useLoginStatusQuery(enabled)

  useEffect(() => {
    if (isLoggedIn) {
      // 一度空のHTMLを返した後にブラウザ側でDOM構築する関係上、通常のアンカーリンクが機能しないためページ表示後一度だけスクロールさせます。
      scrollToHashWithoutSmooth()
    }
  }, [isLoggedIn])

  if (!enabled || isLoggedIn) {
    return <>{children}</>
  }

  if (isLoggedIn === undefined) {
    return fallback ?? null
  }

  redirectToLogin()
  return null
}
